import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import { dateToStringWithFormat } from 'utils/dateUtils';
import makeRequest from 'utils/makeRequest';
import ElementInView from 'components_v2/common/ElementInView/ElementInView';
import s from './LiveblogWidgetRhs.scss';

function fetchData(feedUrl, isWapView, callback) {
  makeRequest
    .get(feedUrl, { isMobile: isWapView }, 'skipfeedengine')
    .catch(err => console.log(err))
    .then(data => {
      if (
        data &&
        data.status === 200 &&
        data.data &&
        typeof callback === 'function'
      ) {
        callback(data.data);
      }
    });
}

class LiveblogWidgetRhs extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const { liveblogData: { refreshinterval } } = this.props;
    if (refreshinterval) {
      this.refreshData();
    }
    this.fetchLBData();
  }

  fetchLBData = () => {
    const { liveblogData, isWapView } = this.props;
    fetchData(liveblogData.dataUrl, isWapView, data => {
      if (data && data.data) {
        this.setState({
          liveblogData: {
            news: {
              items: [...data.data.contents],
              lbgcount: data.data.totalCount,
              lastupd: data.lastupd,
            },
            title1: data.title1,
            wu: data.wu,
            msid: data.msid,
            imagesize: data.imagesize,
          },
        });
        // if (typeof this.props.setTitle === 'function') {
        //   this.props.setTitle(data.title1);
        // }
      }
    });
  };

  refreshData = () => {
    const { liveblogData: { refreshinterval } } = this.props;
    this.refreshInterval = setInterval(() => {
      this.fetchLBData();
    }, refreshinterval * 1000);
  };

  componentWillUnmount() {
    clearInterval(this.refreshInterval);
  }

  renderStory = () => {
    let { liveblogData = {} } = this.state;
    if (!liveblogData.news) {
      liveblogData = Object.assign({}, this.props.liveblogData);
    }
    const { isWapView, storiesCount } = this.props;
    const { news } = liveblogData;
    const { items } = news;
    return (
      <>
        <div className={`${s.lbheading} lbheading`}>{news.name}</div>
        {!isWapView && (
          <div className={s.lbContentscrollcontent}>
            {Array.isArray(items) &&
              items.map(
                (story, index) =>
                  index < storiesCount ? (
                    <div className={s.lbContent} key={index}>
                      <div className={s.content}>
                        <div className={s.time}>
                          <span>
                            {dateToStringWithFormat(
                              story.timestamp,
                              'HH:mm [(IST)] MMM DD',
                            )}
                          </span>
                        </div>
                        <div className={s.text}>{story.title}</div>
                      </div>
                    </div>
                  ) : null,
              )}
          </div>
        )}
      </>
    );
  };

  render() {
    let { liveblogData = {} } = this.state;
    const { themeClass, hideLiveBtn, wrapperClass } = this.props;
    if (!liveblogData.news) {
      liveblogData = Object.assign({}, this.props.liveblogData);
    }
    const { wu, news, msid, imagesize, title1 } = liveblogData;
    if (!news || !Array.isArray(news.items)) {
      return null;
    }

    let isLiveblogActive = false;
    if (liveblogData && liveblogData.news.lastupd) {
      isLiveblogActive =
        Date.now() - liveblogData.news.lastupd * 1000 < 1 * 60 * 60 * 1000;
    }

    return (
      <div
        className={`${s.liveblog} ${!isLiveblogActive ? s.LBnotactive : ''} ${
          themeClass ? s.electionTheme : ''
        } ${wrapperClass ? s[wrapperClass] : ''}`}
      >
        {isLiveblogActive &&
          !hideLiveBtn && (
            <div className={s.blinker}>
              <i className={`${s.liveBtn} ${s.red}`} />
              {!themeClass && <span>Live Now</span>}
            </div>
          )}
        <div className={s.lbheading}>
          <ElementInView gaAction="View" gaLabel="RC_LiveBlog">
            {title1}
          </ElementInView>
        </div>
        <div className={s.lbimg}>
          <Link to={wu} data-newga={`Click#RC_LiveBlog_${wu}`} target="_blank">
            <div className={s.lbimgIn}>
              <div className={s.contentn}>
                <Image
                  msid={msid}
                  imgsize={imagesize}
                  height="146"
                  width="260"
                />
              </div>
            </div>
          </Link>
        </div>
        {this.renderStory()}
        <div className={`${s.moreupdate} moreupdate`}>
          <Link to={wu} data-newga={`Click#RC_LiveBlog_${wu}`} target="_blank">
            {news.lbgcount} More Updates
          </Link>
        </div>
      </div>
    );
  }
}

LiveblogWidgetRhs.propTypes = {
  liveblogData: PropTypes.shape({
    refreshinterval: PropTypes.number,
    dataUrl: PropTypes.string,
    path: PropTypes.string,
  }),
  storiesCount: PropTypes.number,
  isWapView: PropTypes.bool,
  themeClass: PropTypes.string,
};
LiveblogWidgetRhs.defaultProps = {
  liveblogData: {},
  storiesCount: 1,
  isWapView: false,
  themeClass: '',
};

export default LiveblogWidgetRhs;
